import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './FormGroup.styles';

const FormGroup = props => {
  let { styles: customStyles, children, ...rest } = props;
  if (!(children instanceof Array) && children instanceof Object) {
    children = [children];
  }
  if (children instanceof Array) {
    children = children.map((child, index) => {
      return React.cloneElement(child, {
        key: index,
        styles: [child.props.styles, styles.field]
      });
    });
  }
  return (
    <div className={css(styles.group, props.styles)} {...rest}>
      {children}
    </div>
  );
};

export default FormGroup;



// WEBPACK FOOTER //
// ./src/components/forms/formgroup/FormGroup.js